import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

const title = "Help & Support";

export const helpAndSupport: IMcAppType = {
  name: "helpAndSupport",
  description: "Help & Support Landing Page",
  path: "/help-support",
  parameters: {
    properties: {
      context: {
        // this should be an enum
        type: "string",
        description: "Customer Context (unauth or auth)",
      },
    },
  },
  navFlow: NavFlow.TAB,
  parent: Tab.HELP,
  title,
  ignorePathMapping: true,
};

export const helpAndSupportDeepLink: IMcAppType = {
  name: "helpAndSupportDeepLink",
  description: "Help & Support Deep link (not landing page)",
  path: "/help-support/:category?/:subcategory?/:title?",
  parameters: {
    properties: {
      context: {
        // this should be an enum
        type: "string",
        description: "Customer Context (unauth or auth)",
      },
      category: {
        description: "Help & Support Category",
        type: "string",
      },
      subcategory: {
        description: "Help & Subcategory",
        type: "string",
      },
      title: {
        description:
          "Title of the given article, this will be derived if different from article",
        type: "string",
      },
    },
  },
  navFlow: NavFlow.MODAL,
  parent: Tab.HELP,
  title,
};
